import { render, staticRenderFns } from "./MacronutrientsTable.vue?vue&type=template&id=7203705f&scoped=true&"
import script from "./MacronutrientsTable.vue?vue&type=script&lang=js&"
export * from "./MacronutrientsTable.vue?vue&type=script&lang=js&"
import style0 from "./MacronutrientsTable.vue?vue&type=style&index=0&id=7203705f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203705f",
  null
  
)

export default component.exports